import ggoInlineIconStyles from './ggo-improve-icon.module.scss'

export const GGOImproveIcon = () => (
  <svg
    className={ggoInlineIconStyles.ggoInlineIcon}
    width="34"
    height="28"
    viewBox="0 0 34 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11091_21167)">
      <path
        d="M27.3511 10.5674C27.2998 10.5126 27.2282 10.4423 27.1601 10.3755C27.1184 10.3346 27.078 10.295 27.0445 10.2611C26.4378 9.65583 25.8669 9.19031 25.5194 8.99338L25.5228 8.98779C25.3363 8.64769 24.8656 8.07164 24.2562 7.46206C23.6468 6.85248 23.0759 6.38697 22.7311 6.19437L22.7233 6.2022C22.5302 5.85963 22.0563 5.27245 21.4604 4.67696C21.3639 4.58043 21.2703 4.48833 21.1846 4.40916L21.1429 4.45078C21.15 4.44185 21.1576 4.43336 21.1656 4.4253C21.6046 3.98638 23.3404 5.01064 25.0428 6.71305C26.7171 8.38733 27.7355 10.094 27.3511 10.5674Z"
        fill="#017467"
      />
      <g filter="url(#filter0_i_11091_21167)">
        <path
          d="M13.5498 12.0415L12.1157 13.4746L10.9745 17.4569L14.2557 20.7386L18.2385 19.5975L19.6727 18.1644L13.5498 12.0415Z"
          fill="#FFEAC2"
        />
        <path d="M10.9723 17.4572L9.64941 22.0621L14.2542 20.7391L10.9723 17.4572Z" fill="#FFEAC2" />
      </g>
      <path d="M10.9723 17.4573L9.64941 22.0622L14.2542 20.7392L10.9723 17.4573Z" fill="#565B6C" />
      <g filter="url(#filter1_i_11091_21167)">
        <path
          d="M22.7312 6.19434C23.076 6.38693 23.6469 6.85245 24.2563 7.46202C24.8657 8.0716 25.3364 8.64765 25.5228 8.98775L18.4588 16.05L17.4895 17.021C16.673 17.311 15.7707 17.1665 15.1604 16.5578C14.5502 15.949 14.4113 15.0515 14.6905 14.235L15.6693 13.2615L22.7312 6.19434Z"
          fill="#01B19D"
        />
      </g>
      <g filter="url(#filter2_i_11091_21167)">
        <path
          d="M27.3557 10.5721C27.3042 10.5166 27.2302 10.4441 27.1601 10.3753C27.1184 10.3344 27.0781 10.2948 27.0445 10.2609C26.4378 9.65561 25.8669 9.19009 25.5195 8.99316L17.4825 17.0247L17.4755 17.0367C17.2059 17.8507 17.3448 18.7482 17.9455 19.3595C18.0399 19.4461 18.1342 19.5325 18.2423 19.5951L27.3557 10.5721Z"
          fill="#089585"
        />
      </g>
      <g filter="url(#filter3_i_11091_21167)">
        <path
          d="M21.1846 4.40894C21.2703 4.48811 21.364 4.58021 21.4604 4.67674C22.0606 5.27647 22.537 5.86778 22.7274 6.20926L14.6835 14.2392C13.8738 14.5169 12.962 14.3752 12.3639 13.7734C12.267 13.6773 12.1797 13.5789 12.1208 13.4729L21.1846 4.40894Z"
          fill="#089585"
        />
      </g>
      <path
        d="M12.5729 6.8781C13.2741 7.09366 13.8229 7.64253 14.0385 8.34367C14.1026 8.55201 14.3975 8.55199 14.4615 8.34366C14.6771 7.64251 15.226 7.09366 15.9271 6.8781C16.1354 6.81404 16.1354 6.51912 15.9271 6.45507C15.226 6.2395 14.6771 5.69064 14.4615 4.9895C14.3975 4.78116 14.1026 4.78117 14.0385 4.98951C13.8229 5.69066 13.2741 6.23951 12.5729 6.45507C12.3646 6.51913 12.3646 6.81404 12.5729 6.8781Z"
        fill="#01B19D"
      />
      <path
        d="M7.15108 9.73386C8.2028 10.0572 9.02607 10.8805 9.34942 11.9322C9.44551 12.2447 9.88788 12.2447 9.98397 11.9322C10.3073 10.8805 11.1306 10.0572 12.1823 9.73385C12.4948 9.63776 12.4948 9.19539 12.1823 9.09931C11.1306 8.77596 10.3073 7.95267 9.98395 6.90095C9.88787 6.58845 9.44549 6.58847 9.34942 6.90097C9.02607 7.95269 8.20278 8.77597 7.15106 9.09932C6.83855 9.1954 6.83857 9.63777 7.15108 9.73386Z"
        fill="#01B19D"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_11091_21167"
        x="9.64941"
        y="12.0415"
        width="10.0233"
        height="10.0205"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.83333" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.65098 0 0 0 0 0 0 0 0 1 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_11091_21167" />
      </filter>
      <filter
        id="filter1_i_11091_21167"
        x="14.5526"
        y="6.19434"
        width="10.9702"
        height="10.9707"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.375" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.00392157 0 0 0 0 0.513726 0 0 0 0 0.454902 0 0 0 0.5 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_11091_21167" />
      </filter>
      <filter
        id="filter2_i_11091_21167"
        x="17.3439"
        y="8.99316"
        width="10.0118"
        height="10.6018"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.375" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.00392157 0 0 0 0 0.454902 0 0 0 0 0.403922 0 0 0 0.5 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_11091_21167" />
      </filter>
      <filter
        id="filter3_i_11091_21167"
        x="12.1208"
        y="4.40894"
        width="10.6066"
        height="9.9668"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.375" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.00392157 0 0 0 0 0.454902 0 0 0 0 0.403922 0 0 0 0.5 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_11091_21167" />
      </filter>
      <clipPath id="clip0_11091_21167">
        <rect width="22" height="22" fill="white" transform="translate(6 3)" />
      </clipPath>
    </defs>
  </svg>
)
